var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuDeleat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_24438",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 24438",
    transform: "translate(-324 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_20567",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 20567",
    transform: "translate(-4.5 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_907",
    "data-name": "\\u7DDA 907",
    d: "M16.939,19.061l-18-18L1.061-1.061l18,18Z",
    transform: "translate(331.5 20.5)",
    fill: "#a59785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_908",
    "data-name": "\\u7DDA 908",
    d: "M1.061,19.061l-2.121-2.121,18-18,2.121,2.121Z",
    transform: "translate(331.5 20.5)",
    fill: "#a59785"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_12495",
    "data-name": "\\u9577\\u65B9\\u5F62 12495",
    width: 24,
    height: 24,
    transform: "translate(324 14)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuDeleat);
export default __webpack_public_path__ + "static/media/icon_menu_deleat.82c8224a74ccd69e15aa04b2a702a11b.svg";
export { ForwardRef as ReactComponent };